// extracted by mini-css-extract-plugin
export default {"formWrapper":"styles_formWrapper__8nbCI"};